import { SignatureProps } from "../App";
import ImageLogo from "./ImageLogo";

const Signature = ({
  fullName,
  position,
  phone,
  banners,
  selectedBannerType,
}: SignatureProps) => {
  return (
    <table
      cellPadding={0}
      cellSpacing={0}
      className={"signature"}
      style={{
        fontFamily: "Arial, Helvetica, sans-serif",
        width: "100%",
        maxWidth: 600,
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              backgroundImage: "linear-gradient(0deg, #0960F6 0%, #8839F5 50%, #FF290C 100%)",
              padding: 2,
            }}
          ></td>
          <td>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                      color: "#FF290C",
                      paddingTop: 2,
                      paddingLeft: 24,
                    }}
                  >
                    {fullName}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {position}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={24} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {phone ? (
                      <>
                        <strong>M. </strong>
                        {phone}
                      </>
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <a
                      href={"https://www.roller.software/"}
                      style={{ display: "flex" }}
                    >
                      <img
                        width={146}
                        src="https://signature.rollersoftware.com/email-logo.png"
                        alt="ROLLER - All-in-on Venue Management software"
                        title="Roller"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <div
                      style={{
                        display: "flex",
                        fontSize: 12,
                        color: "#011840",
                        letterSpacing: -0.16,
                        fontWeight: 400,
                        paddingTop: 8,
                      }}
                    >
                      <a
                        href={"https://www.roller.software/"}
                        title="ROLLER - All-in-on Venue Management software"
                        style={{ color: "#011840" }}
                      >
                        Website
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={"https://www.linkedin.com/company/roller/"}
                        title="ROLLER - LinkedIn"
                        style={{ color: "#011840" }}
                      >
                        LinkedIn
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={
                          "https://www.roller.software/the-guest-experience-show/"
                        }
                        title="ROLLER - The Guest Experience"
                        style={{ color: "#011840" }}
                      >
                        Podcast
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingTop: 24 }}>
                    <a
                      href={
                        selectedBannerType &&
                        banners &&
                        banners[selectedBannerType]
                          ? banners[selectedBannerType].linkUrl
                          : ""
                      }
                      style={{ display: "flex" }}
                      title="ROLLER - All-in-on Venue Management software"
                    >
                      <img
                        src={
                          selectedBannerType &&
                          banners &&
                          banners[selectedBannerType]
                            ? banners[selectedBannerType].imageUrl
                            : ""
                        }
                        width={596}
                        alt="ROLLER - All-in-on Venue Management software"
                        style={{
                          width: "100%",
                          maxWidth: 596,
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                      paddingTop: 24,
                      paddingBottom: 18,
                    }}
                  >
                    Check out our consistently high industry ratings:
                  </td>
                </tr>
              </tbody>
            </table>
            {/*
              Email clients (esp. Gmail) ignore external CSS grid/flex.
              Keep badges in one horizontal row with a table + inline styles,
              and use absolute HTTPS image URLs so pasted signatures load.
            */}
            <table
              cellPadding={0}
              cellSpacing={0}
              border={0}
              role="presentation"
              style={{ borderCollapse: "collapse" }}
            >
              <tbody>
                <tr>
                  <td style={{ paddingLeft: 24, paddingTop: 8 }}>
                    <table
                      cellPadding={0}
                      cellSpacing={0}
                      border={0}
                      role="presentation"
                      style={{ borderCollapse: "collapse" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://www.softwareadvice.com/retail/web-based-point-of-sale-software-comparison/#frontrunners"
                              title="ROLLER - Software Advice"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                src="https://signature.rollersoftware.com/software-advice.png"
                                alt="ROLLER - Software Advice"
                                width={64}
                                fallbackSrc="/software-advice.png"
                                title="ROLLER - Software Advice"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://www.g2.com/products/roller-software/reviews?utm_source=rewards-badge"
                              title="ROLLER - G2"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                width={48}
                                src="https://signature.rollersoftware.com/users-love-us.png"
                                fallbackSrc="/users-love-us.png"
                                alt="ROLLER - G2"
                                title="ROLLER - G2"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://www.capterra.com/point-of-sale-software/shortlist"
                              title="ROLLER - Capterra"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                src="https://signature.rollersoftware.com/capterra.png"
                                alt="ROLLER - Capterra"
                                width={68}
                                fallbackSrc="/capterra.png"
                                title="ROLLER - Capterra"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://sourceforge.net/software/product/ROLLER/"
                              title="ROLLER - Sourceforge User Reviews"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                src="https://signature.rollersoftware.com/leader-summer-sourceforge.png"
                                alt="ROLLER - Sourceforge Leader Summer 2026"
                                width={52}
                                fallbackSrc="/leader-summer-sourceforge.png"
                                title="ROLLER - Sourceforge User Reviews"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://www.getapp.com/customer-management-software/point-of-sale/category-leaders"
                              title="ROLLER - GetApp"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                width={64}
                                src="https://signature.rollersoftware.com/getapp.png"
                                fallbackSrc="/getapp.png"
                                alt="ROLLER - GetApp"
                                title="ROLLER - GetApp"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td
                            valign="middle"
                            style={{ paddingRight: 12, verticalAlign: "middle" }}
                          >
                            <a
                              href="https://slashdot.org/software/p/ROLLER/"
                              title="ROLLER - Slashdot User Reviews"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                src="https://signature.rollersoftware.com/leader-summer-slashdot.png"
                                alt="ROLLER - Slashdot Leader Summer 2026"
                                title="ROLLER - Slashdot User Reviews"
                                width={46}
                                fallbackSrc="/leader-summer-slashdot.png"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                          <td valign="middle" style={{ verticalAlign: "middle" }}>
                            <a
                              href="https://topbusinesssoftware.com/products/ROLLER/reviews/"
                              title="ROLLER - Top Business Software Reviews"
                              style={{ textDecoration: "none", border: 0 }}
                            >
                              <ImageLogo
                                src="https://signature.rollersoftware.com/top-rated-summer-tbs.png"
                                alt="ROLLER - Top Business Software Top Rated Summer 2026"
                                title="ROLLER - Top Business Software Reviews"
                                width={52}
                                fallbackSrc="/top-rated-summer-tbs.png"
                                style={{ display: "inline-block", border: 0 }}
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Signature;
